// extracted by mini-css-extract-plugin
module.exports = {"mapDiv":"GoogleMap_mapDiv__3VkUJ","loadingText":"GoogleMap_loadingText__3QIlu"};